import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.png`} alt="" />
      </Link>
      <header>
        <h2>Mehmet Erim Tuzcuoğlu</h2>
        <p><a href="mailto:erimtuzcuoglu@gmail.com">erimtuzcuoglu@gmail.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About Me</h2>
      <p>Hey there! I&apos;m Erim, a Senior Backend Developer at&nbsp;
        <a href="https://otorento.com.tr">Otorento</a> with 6+ years
        of experience building scalable backend systems.
        I specialize in .NET and Node.js, crafting high-performance
        APIs and microservices that power production applications.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Mehmet Erim Tuzcuoglu <Link to="/">erimt.dev</Link>.</p>
    </section>
  </section>
);

export default SideBar;
